module.exports = __webpack_public_path__ + "img/main.16c10fa5.png";